import { axiosInstance } from "../../configuration";
const API_URL = "https://ledbackend.onrender.com/api/inventory/";

// CreateProduct user
const createProduct = async (userData) => {
  const response = await axiosInstance.post(API_URL, userData);

  if (response.data) {
    localStorage.setItem("product", JSON.stringify(response.data));
  }

  return response.data;
};

const productService = {
  createProduct,
};

export default productService;
